import React from "react";
import { Alert, Typography } from "antd";
import { zoneIsSupported, zoneLabel } from "./slotTime";

// States which time zone a calendar's hours are in, so nobody has to guess.
export const TimezoneNote: React.FC = () => {
  if (!zoneIsSupported()) {
    return (
      <Alert
        type="warning"
        showIcon
        style={{ margin: "8px 0" }}
        message="Times are shown in UTC"
        description="Your time zone is offset from UTC by a part of an hour, which this calendar can't show accurately yet, so hours are in UTC."
      />
    );
  }
  return (
    <Typography.Text type="secondary" style={{ display: "block", margin: "8px 0" }}>
      Times are shown in your time zone: <strong>{zoneLabel()}</strong>
    </Typography.Text>
  );
};
